export default __webpack_public_path__ + "static/media/Brow_2_C2.70e0d1bb.svg";